import React from 'react';
import { Form, message } from 'antd';
import { useCreateGroupAtOnceMutation, namedOperations } from 'graphql/types';
import { useHistory } from 'react-router-dom';
import { ResizeImageResult, ParseGoogleAddressResult } from 'helpers';
import StepBarForm from 'components/stepBarForm';
import CoverPhotoStep from './coverPhotoStep';
import InformationStep from './informationStep';
import AddCategoriesStep from '../category/addCategoriesStep';

interface FromFields {
  name: string;
  description: string;
  categories: string[];
  coverPhoto: ResizeImageResult;
  address: ParseGoogleAddressResult;
  managers?: string[];
}

const steps = [
  {
    title: 'Informations',
    pageTitle: 'Add Group Details',
    validation: ['name', 'description', 'groupType', 'address'],
    content: InformationStep,
  },
  {
    title: 'Categories',
    pageTitle: 'Select related categories',
    validation: ['categories'],
    content: AddCategoriesStep,
  },
  { title: 'Cover Photo', pageTitle: 'Add Cover Photo', validation: ['coverPhoto'], content: CoverPhotoStep },
];

function CreateGroup() {
  const [form] = Form.useForm();
  const [createGroup, { loading }] = useCreateGroupAtOnceMutation({
    refetchQueries: [namedOperations.Query.GetMyAccount],
  });
  const history = useHistory();

  const onFinish = async (values: FromFields) => {
    const attributes = { ...values, coverPhoto: values.coverPhoto.blob };
    try {
      const result = await createGroup({
        variables: { input: attributes },
      });
      const groupSlug = result.data?.createGroupAtOnce?.data?.attributes?.slug;
      if (groupSlug) {
        history.push(`/groups/${groupSlug}`);
      }
    } catch (err) {
      if (err instanceof Error) {
        message.error(err.message);
      }
    }
  };

  const handlePageBack = () => {
    if (history.length > 1) {
      history.goBack();
      return;
    }
    history.push('/account/groups');
  };

  return (
    <StepBarForm
      pageTitle="Make new Group"
      form={form}
      onFinish={onFinish}
      loading={loading}
      steps={steps}
      onPageBack={handlePageBack}
    />
  );
}

export default CreateGroup;
